import { Injectable } from '@angular/core';
import { CoreApiService } from 'src/app/core/core-api.service';
import { endpoints } from 'src/environments/endpoints';

@Injectable({
  providedIn: 'root'
})
export class DdiService {

  constructor(private apiService: CoreApiService) { }


  consultaDDI(){
    return this.apiService.get(endpoints.listarDdi)
  }
}
